"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.materialize = void 0;
const react_async_hook_1 = require("react-async-hook");
const content_type_1 = __importDefault(require("content-type"));
const stereotype_api_1 = require("../apis/stereotype.api");
const constants_1 = require("../constants");
const getHtmlEnforcedProcessors = (processors) => {
    const blackListProcessorsPostMjml = ['edie', 'ediecsv', 'edietext', 'htmlpdf', 'mime', 'mjml', 'xlsx'];
    const mjmlProcessorIndex = processors.findIndex((prc) => prc === 'mjml');
    return mjmlProcessorIndex
        ? [...processors.slice(0, mjmlProcessorIndex + 1), ...processors.slice(mjmlProcessorIndex).filter(prc => !blackListProcessorsPostMjml.includes(prc))]
        : processors;
};
exports.materialize = (enforceHtmlProcessor, shouldProducePdfOutput, accessToken, templateUrl, payload, crawlingOptions) => {
    var _a, _b, _c, _d, _e;
    const getContentType = () => {
        if (payload && JSON.stringify(payload).includes("_links")) {
            return 'application/hal+json';
        }
        return 'application/json';
    };
    const response = react_async_hook_1.useAsync(() => __awaiter(void 0, void 0, void 0, function* () {
        var _f;
        const templateDetails = yield stereotype_api_1.getTemplate(accessToken, templateUrl);
        const parsedContentType = content_type_1.default.parse(templateDetails.contentType);
        let processors = parsedContentType.parameters.processors ? parsedContentType.parameters.processors.split(',') : [];
        const postProcessors = parsedContentType.parameters.postProcessors ? parsedContentType.parameters.postProcessors.split(',') : [];
        if (constants_1.edieTemplateTypes.includes(templateDetails.templateType) && enforceHtmlProcessor) {
            processors = processors.length ? getHtmlEnforcedProcessors(processors) : constants_1.edie2htmlProcessors;
        }
        if (templateDetails.templateType === 'raw' && enforceHtmlProcessor && !postProcessors.includes('mjml')) {
            postProcessors.push('mjml');
        }
        shouldProducePdfOutput && postProcessors.push('htmlpdf');
        const contentTypeOverride = {
            type: getContentType(),
            parameters: {}
        };
        processors.length > 0 && (contentTypeOverride.parameters.processors = processors.join(','));
        postProcessors.length > 0 && (contentTypeOverride.parameters.postProcessors = postProcessors.join(','));
        const response = yield stereotype_api_1.materializeTemplate(accessToken, templateUrl, payload, content_type_1.default.format(contentTypeOverride), crawlingOptions);
        const materializationText = yield ((_f = response.result) === null || _f === void 0 ? void 0 : _f.text());
        return [response.result, materializationText, response.contentType, templateDetails];
    }), [enforceHtmlProcessor, shouldProducePdfOutput, accessToken, templateUrl, JSON.stringify(payload), JSON.stringify(crawlingOptions)]);
    return {
        materializationBlob: (_a = response === null || response === void 0 ? void 0 : response.result) === null || _a === void 0 ? void 0 : _a[0],
        materializationText: (_b = response === null || response === void 0 ? void 0 : response.result) === null || _b === void 0 ? void 0 : _b[1],
        contentType: (_c = response === null || response === void 0 ? void 0 : response.result) === null || _c === void 0 ? void 0 : _c[2],
        fetchingError: response.error,
        fetching: response.loading,
        templateType: (_e = (_d = response.result) === null || _d === void 0 ? void 0 : _d[3]) === null || _e === void 0 ? void 0 : _e.templateType
    };
};
//# sourceMappingURL=useMaterialization.js.map